"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var NewLanding = function NewLanding() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "18",
    height: "19",
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.6577 13.7557L0.5 9.54805V4.58655L1.65383 4.95193L2.35383 7.07118L7.25 8.45V0.5L8.80765\n0.884625L11.5577 9.63463L16.4423 11.0058C16.7679 11.093 17.0256 11.2667 17.2153 11.5269C17.4051\n11.7872 17.5 12.0801 17.5 12.4058C17.5 12.8724 17.307 13.2468 16.9211 13.5288C16.5352 13.8109\n16.1141 13.8865 15.6577 13.7557ZM0.5 18.5V17H17.5V18.5H0.5Z",
    fill: "#6E6D71"
  }));
};
var _default = NewLanding;
exports.default = _default;